const init = () => {

	// First, check that geolocation is supported in browser
	if ('geolocation' in navigator) {

		// Loop through elements
		for (const trigger of document.querySelectorAll('[data-location-requester]')) {

			// Add attr to make trigger visible
			trigger.setAttribute('data-location-requester', 'visible');
			
			// Add click event to trigger location request
			trigger.addEventListener('click', requestLocation);
		}
	}
}

// Request user location
const requestLocation = (e) => {

	// Get element that was triggered
	const target = e.target;

	// Dispatch custom events depending on if location request allowed or blocked
	navigator.geolocation.getCurrentPosition(function(position) {

		target.dispatchEvent(new CustomEvent('location-allowed', {
			bubbles: true,
			detail: position
		}));

	}, function(error) {

		target.dispatchEvent(new CustomEvent('location-blocked', {
			bubbles: true,
			detail: error
		}));

	});
}

export default init;